import * as React from 'react';

// let timer = null;
let timer = null;
class Wait extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      waitTimeCount: 10,
    };
  }
  UNSAFE_componentWillMount() {
    // 创建定时器
    timer = setInterval(
      () => {
        if (this.state.waitTimeCount <= 0) {
          // this.props.history.push('/personal');
          // console.log('清除定时器');
          timer && clearInterval(timer);
          this.toIndex();
        } else {
          this.setState({ waitTimeCount: this.state.waitTimeCount - 1 })
          // console.log(this.state.waitTimeCount);
        }
      },
      1000
    );
  }
  UNSAFE_componentWillUnmount() {
    timer && clearInterval(timer);

  }
  // 跳转到个人中心页面
  toIndex = () => {
    // console.log('跳转到个人中心页面');
    this.props.history.push('/report');
  }
  toSerch = () => {
    // console.log('跳转到关键词搜索页面');
    timer && clearInterval(timer);
    this.props.history.push('/service/search');
  }
  render() {
    return (
      <React.Fragment>
        <div className="top"></div>
        <div className="sand-box">
          <div className="sand"></div>
        </div>
        <div className="a">
          <div className="text">关键词已提交，棍棍正在十万火急计算，请耐心等待1个工作日左右…</div>
          <div className="text mt">有结果后，棍棍会通知您呦！</div>
          <div className="time">
            <div className="txt">进入个人中心倒计时：</div>
            <div className="numb">{this.state.waitTimeCount}s</div>
          </div>
        </div>
        <div className="a">
          <div className="btm">
            <div className="logo"></div>
            <div className="text" onClick={() => { this.toSerch(); }}>去了解下其他感兴趣的内容</div>
          </div>
        </div>

      </React.Fragment>
    );
  }
}

export default Wait;
